import { render, staticRenderFns } from "./ListDossiers.vue?vue&type=template&id=47e3f12a&scoped=true&"
import script from "./ListDossiers.vue?vue&type=script&lang=js&"
export * from "./ListDossiers.vue?vue&type=script&lang=js&"
import style0 from "./ListDossiers.vue?vue&type=style&index=0&id=47e3f12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e3f12a",
  null
  
)

export default component.exports